import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    marginLeft: '0.625rem',
    marginRight: '0.625rem',
  },

  tooltip: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#333',
    color: '#fff',
    padding: '6px 10px',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    zIndex: 1000,
    marginBottom: '6px',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
})

export default useStyles
